/* @flow */

import { makeIDLink } from './utils';

export default makeIDLink({ pathname: '/files' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/FileLink.js